import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color, strokeWidth }) => (
  <svg viewBox="0 0 92 89">
    <g clipPath="url(#clip0_1_162)">
      <rect width="92" height="89" fill="white" />
      <rect
        x="2"
        y="2"
        width="88"
        height="73.4737"
        rx="8"
        stroke="url(#paint0_linear_1_162)"
        strokeWidth="4"
        fill="white"
      />
      <circle cx="8" cy="8" r="2" fill="url(#paint1_linear_1_162)" />
      <circle cx="14" cy="8" r="2" fill="url(#paint2_linear_1_162)" />
      <circle cx="20" cy="8" r="2" fill="url(#paint3_linear_1_162)" />
      <rect width="57" height="53" transform="translate(18 36)" fill="white" />
      <path
        d="M46.625 61.5625C44.9703 61.5631 43.371 62.1591 42.1195 63.2416C40.868 64.3241 40.0478 65.8209 39.8089 67.4583C39.57 69.0957 39.9283 70.7644 40.8183 72.1594C41.7083 73.5544 43.0707 74.5825 44.6562 75.0558V79.2812C44.6562 79.8034 44.8637 80.3042 45.2329 80.6734C45.6021 81.0426 46.1029 81.25 46.625 81.25C47.1471 81.25 47.6479 81.0426 48.0171 80.6734C48.3863 80.3042 48.5938 79.8034 48.5938 79.2812V75.0558C50.1793 74.5825 51.5417 73.5544 52.4317 72.1594C53.3217 70.7644 53.68 69.0957 53.4411 67.4583C53.2022 65.8209 52.382 64.3241 51.1305 63.2416C49.879 62.1591 48.2797 61.5631 46.625 61.5625ZM46.625 71.4062C46.0409 71.4062 45.47 71.2331 44.9843 70.9086C44.4987 70.5841 44.1202 70.1228 43.8967 69.5832C43.6732 69.0436 43.6147 68.4499 43.7286 67.877C43.8426 67.3041 44.1238 66.778 44.5368 66.365C44.9498 65.952 45.476 65.6707 46.0489 65.5567C46.6217 65.4428 47.2155 65.5013 47.7551 65.7248C48.2947 65.9483 48.7559 66.3268 49.0804 66.8125C49.4049 67.2981 49.5781 67.8691 49.5781 68.4531C49.5781 69.2363 49.267 69.9875 48.7132 70.5413C48.1594 71.0951 47.4082 71.4062 46.625 71.4062ZM66.3125 53.6875H58.4375V47.7812C58.4375 44.6484 57.193 41.6438 54.9777 39.4286C52.7624 37.2133 49.7579 35.9688 46.625 35.9688C43.4921 35.9688 40.4876 37.2133 38.2723 39.4286C36.057 41.6438 34.8125 44.6484 34.8125 47.7812V53.6875H26.9375C25.8932 53.6875 24.8917 54.1023 24.1533 54.8408C23.4148 55.5792 23 56.5807 23 57.625V85.1875C23 86.2318 23.4148 87.2333 24.1533 87.9717C24.8917 88.7102 25.8932 89.125 26.9375 89.125H66.3125C67.3568 89.125 68.3583 88.7102 69.0967 87.9717C69.8352 87.2333 70.25 86.2318 70.25 85.1875V57.625C70.25 56.5807 69.8352 55.5792 69.0967 54.8408C68.3583 54.1023 67.3568 53.6875 66.3125 53.6875ZM38.75 47.7812C38.75 45.6927 39.5797 43.6896 41.0565 42.2128C42.5334 40.7359 44.5364 39.9062 46.625 39.9062C48.7136 39.9062 50.7166 40.7359 52.1935 42.2128C53.6703 43.6896 54.5 45.6927 54.5 47.7812V53.6875H38.75V47.7812ZM66.3125 85.1875H26.9375V57.625H66.3125V85.1875Z"
        fill="url(#paint4_linear_1_162)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_162"
        x1="0"
        y1="38.7368"
        x2="92"
        y2="38.7368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005F94" />
        <stop offset="1" stopColor="#0DB7E1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_162"
        x1="6"
        y1="8"
        x2="10"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005F94" />
        <stop offset="1" stopColor="#0DB7E1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_162"
        x1="12"
        y1="8"
        x2="16"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005F94" />
        <stop offset="1" stopColor="#0DB7E1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_162"
        x1="18"
        y1="8"
        x2="22"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005F94" />
        <stop offset="1" stopColor="#0DB7E1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_162"
        x1="23"
        y1="62.5469"
        x2="70.25"
        y2="62.5469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005F94" />
        <stop offset="1" stopColor="#0DB7E1" />
      </linearGradient>
      <clipPath id="clip0_1_162">
        <rect width="92" height="89" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} />],
    ['fill', <Icon color={color} strokeWidth={16} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const Locked = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

Locked.displayName = 'Locked';
